import React, { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useQueries } from 'lib/utils/request';
import { useSpots } from '../../../lib/spots';
import { getCurrentLocation, getDistanceBetween } from '../../../lib/utils/map';
import { UserPage } from '../../../components/UserPage';
import { TabSection } from '../../../components/TabSection';
import { Details } from './tabs/Details';
import { LocationMap } from './tabs/LocationMap';
import { StampCard } from './tabs/StampCard';
import { Flash } from '../../../components/Flash';
import { CheckIn } from 'components/CheckIn';


type Props = {};

export const SpotDetails: FC<Props> = (props) => {
    const [spot, setSpot] = useState<Spot>();
    const { get } = useSpots();
    // @ts-ignore
    const id = props.match.params.id;
    const query = useQueries();
    const history = useHistory();
    const [isCheckin, setIsCheckin] = useState(query.get('checkin') != null);
    const [canCheckin, setCanCheckin] = useState<boolean>(false);
    // @ts-ignore
    const flashSettings = props.location?.state?.error
        ? {
            color: '#a94442',
            backgroundColor: '#f2dede',
        }
        : {};

    useEffect(() => {
        async function initialize() {
            const spot = await get(id);
            if (spot) {
                setSpot(spot);
                const currentLocation = await getCurrentLocation();
                if (currentLocation) {
                    const spotLocation = { lat: spot.lat, lng: spot.lng };
                    const distance = getDistanceBetween(currentLocation, spotLocation);
                    setCanCheckin(distance <= 50);
                };
            } else {
                history.push('/map');
            }
        };
        initialize();
    }, []);

    return (
        <UserPage title="Salon.jp | お店詳細" defaultCenter={{ lat: spot?.lat, lng: spot?.lng }}>
            {/* @ts-ignore */}
            <Flash flash={props.location?.state?.flash ?? undefined} {...flashSettings} />
            <TabSection
                tabList={[
                    "トップ",
                    <>
                        <img width="14" style={{ marginRight: "4px" }} src="/img/icon_stamp.png" />
                        スタンプ
                    </>,
                    <>
                        <img width="14" style={{ marginRight: "4px" }} src="/img/icon_map.png" />
                        マップ
                    </>,
                ]}
                contents={[
                    spot ? <Details
                        {...spot as any}
                    /> : null,
                    spot ? <StampCard id={id} spotName={spot.name} /> : null,
                    spot ? <LocationMap {...spot as any} /> : null,
                ]}
            />
            {isCheckin && <CheckIn id={id} />}

            {(canCheckin && spot && !spot.editable && !spot.checkedIn) && (
                <button
                    className="floating-action-button"
                    onClick={() => setIsCheckin(true)}
                >
                    <img src="/img/todays_stamp.png" />
                </button>
            )}

            <style jsx>{`
                .floating-action-button {
                    border-radius: 50%;
                    position: fixed;
                    bottom: 30px;
                    right: 30px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0;
                    border: none;
                    background: none;
                }
                .floating-action-button > img {
                    width: 110px;
                    height: 110px;
                }
                @media screen and (max-width: 540px) {
                    .floating-action-button > img {
                        width: 100px;
                        height: 100px;
                    }
                }
            `}</style>
        </UserPage>
    );
};
